import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue"),
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./views/About.vue")
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () => import("./views/Privacy.vue")
    },
    { path: "*", component: () => import("./views/Home.vue") }
    // {
    //   path: "/hangout",
    //   name: "hangout",
    //   component: () => import("./views/Hangout.vue")
    // },
    // {
    //   path: "/login",
    //   name: "login",
    //   component: () => import("./views/Login.vue")
    // },
    // {
    //   path: "/settings",
    //   name: "settings",
    //   component: () => import("./views/Settings.vue")
    // },
    // {
    //   path: "/shops/credits",
    //   name: "credits-shop",
    //   component: () => import("./views/CreditsShop.vue")
    // },
    // {
    //   path: "/account",
    //   name: "private-account",
    //   component: () => import("./views/PrivateAccount.vue")
    // },
    // {
    //   path: "/support-gc",
    //   name: "support-gc",
    //   component: () => import("./views/SupportUs.vue")
    // },
    // {
    //   path: "/workshop/:deckID?",
    //   name: "workshop",
    //   component: () => import("./views/Workshop.vue")
    // },
    // {
    //   path: "/shops",
    //   name: "shops",
    //   component: () => import("./views/Shops.vue")
    // },
    // {
    //   path: "/shops/cards",
    //   name: "cards-shop",
    //   component: () => import("./views/CardShop.vue")
    // },
    // {
    //   path: "/shops/avatars",
    //   name: "avatars-shop",
    //   component: () => import("./views/AvatarShop.vue")
    // },
    // {
    //   path: "/collection",
    //   name: "collection",
    //   component: () => import("./views/Collection.vue")
    // },
    // {
    //   path: "/achievements",
    //   name: "achievements",
    //   component: () => import("./views/Achievements.vue")
    // },
    // {
    //   path: "/duel/:id",
    //   name: "duel",
    //   component: () => import("./views/Duel.vue")
    // },
    // {
    //   path: "/announcement/:id",
    //   name: "announcement",
    //   component: () => import("./views/Announcement.vue")
    // },
    // {
    //   path: "/user/:username",
    //   name: "user",
    //   component: () => import("./views/Profile.vue")
    // },
    // {
    //   path: "/notifications",
    //   name: "notifications",
    //   component: () => import("./views/Notifications.vue")
    // },
    // {
    //   path: "/___admin",
    //   name: "___admin",
    //   component: () => import("./views/Admin.vue")
    // },
    // { path: "*", component: () => import("./views/Home.vue") }
  ]
});
